<span *ngIf="isFree">{{ 0 | currency:'USD':'symbol':'1.0-0' }}</span>
<span  [ngClass]="{'free' : isFree}">{{ price | currency:'USD' }}</span>
